import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './containers/App';
import AppProvider from './contexts/appContext';
import './index.less';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <AppProvider>
    <BrowserRouter
      getUserConfirmation={() => {
        /* Empty callback to block the default browser prompt */
      }}
      basename={process.env.REACT_APP_BASE_URL}
    >
      <App />
    </BrowserRouter>
  </AppProvider>,
  document.getElementById('root'),
);
serviceWorker.unregister();
